import React, { useEffect, useLayoutEffect, useState } from 'react';
import Linkify from 'react-linkify';
import ReactGA from 'react-ga';

import { IDatabase, IDatabaseField, getAnalyticsToken } from '../../services/database';
import { get as getAttachment, IAttachment } from '../../services/attachment';
import { IOrganization } from '../../services/account';
import {getSepcialPageFieldKeysForDataabse, getSpecialPageFieldKeysForDatabase} from '../../helpers/pages';
import { get as getPage, IPage, getOrganization } from '../../services/pages';

import pdf from '../../images/pdf.png';
import doc from '../../images/doc.png';
import eps from '../../images/eps.png';
import gif from '../../images/gif.png';
import jpg from '../../images/jpg.png';
import psd from '../../images/psd.png';
import xls from '../../images/xls.png';
import Modal from '../../shared/Modal';

interface Props {
    database?: IDatabase,
    pageId: string,
    onClose: () => void
}

const specialKeys = [
    'page_title',
    'organization_name_or_collins_department',
    'resource_description',
    'program_focus_area',
    'resource_type',
    'resource_location',
    'identity_specifier',
    'ages_served',
    'grades_served',
    'program_availability',
    'cost',
    'contact_name',
    'cotnact_phone_number',
    'contact_email',
    'street_address',
    'city',
    'state',
    'zip_code',
    'website_link',
];

export default ({ database, pageId, onClose }: Props) => {
    const [attachments, setAttachments] = useState<IAttachment[]>([]);
    const [page, setPage] = useState<IPage | null>(null);
    const [organization, setOrganization] = useState<IOrganization | null>(null);
    const [show, setShow] = useState<boolean>(!!pageId);

    useLayoutEffect(() => {
        if (show) $('#detailModal').modal('show')
        else $('#detailModal').modal('hide')
    })

    useLayoutEffect(() => {
        $('#detailModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
            setShow(false)
        });
    })

    useEffect(() => {
        if (pageId && !show) onClose()
    }, [show])

    useEffect(() => {
        addTracker();
        loadPage();
        if (pageId) setShow(true)
        else setShow(false)
    }, [pageId, database]);

    const fetchPageAttachments = async (currentPage: IPage) => {
        const att: IAttachment[] = [];
        if (Array.isArray(currentPage.row.map.attachments))
            await Promise.all(
                currentPage.row.map.attachments.map(async (a: string) => {
                    const attachment = await getAttachment(
                        a,
                        typeof currentPage.organization === 'object'
                            ? currentPage.organization.name
                            : currentPage.organization
                    );
                    if (
                        attachment.success &&
                        attachment.data &&
                        !Array.isArray(attachment.data)
                    ) {
                        att.push(attachment.data);
                    }
                })
            );
        setAttachments(att);
    };

    const loadOrganization = async (orgName: string) => {
        const orgResult = await getOrganization(orgName);
        if (orgResult.success && orgResult.organization) {
            setOrganization(orgResult.organization);
        }
    };

    const loadPage = async () => {
        const accountName = typeof database?.account === 'string' ? database?.account : database?.account?.name
        if (!accountName) return
        const pageResult = await getPage(pageId, accountName);
        if (pageResult.success && pageResult.pages) {
            const localPage = pageResult.pages[0];
            await loadOrganization(typeof localPage.organization === 'object'
                ? localPage.organization.name
                : localPage.organization)
            setPage(localPage);
            await fetchPageAttachments(localPage);
        }
    };

    const addTracker = async () => {
        if (!database || !database.name || !page) return;
        try {
            const c = ((await getAnalyticsToken(database.name)) || '').replace(/"/g, '');
            ReactGA.addTrackers([
                {
                    trackingId: c,
                    gaOptions: { name: 'client' },
                },
            ]);
        } catch (ex) {
            console.error(ex);
        }
        const org = typeof page.organization === 'object' && page.organization;
        ReactGA.pageview(
            `${org && org.title}/${page.database && page.database.title}/${page.title}`,
            ['harmonize', 'client']
        );
    };

    const getFileType = (name: string) => {
        const type = (name.split('.').pop() || '').toLocaleLowerCase();
        switch (type) {
            case 'pdf':
                return pdf;
            case 'ppt':
                return doc;
            case 'docx':
                return doc;
            case 'doc':
                return doc;
            case 'png':
                return doc;
            case 'jpg':
                return jpg;
            case 'jpeg':
                return jpg;
            case 'eps':
                return eps;
            case 'gif':
                return gif;
            case 'psd':
                return psd;
            case 'xls':
                return xls;
            case 'xlsx':
                return xls;
            case 'psd':
                return psd;
            default:
                return doc;
        }
    };

    const renderAttachment = (attachment: IAttachment) => (
        <li>
            <div style={{ marginRight: 50 }}>
                <a href={attachment.url} className="attachment-link" target="_blank">
                    <img src={getFileType(attachment.fileName)} className="pb-3" />
                    <p>{attachment.fileName}</p>
                </a>
            </div>
        </li>)

    const renderDetailModalSection = (icon, label, children) => (
        <div style={{ display: 'flex', alignItems: 'start', marginBottom: 20 }}>
            <div style={{ paddingLeft: 20, paddingRight: 10 }}>{icon}</div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h5>{label}</h5>
                <div>{children}</div>
            </div>
        </div>
    );

    const sortList = (list: string[], databaseField: IDatabaseField) => {
        return (Array.isArray(list) && Array.isArray(databaseField?.options)) ? list.sort((a, b) => databaseField.options.indexOf(a) - databaseField.options.indexOf(b)) : list;
    }

    const filterList = (list: string[], databaseField: IDatabaseField) => {
        return (Array.isArray(list) && Array.isArray(databaseField?.options)) ? list.filter((a) => databaseField.options.indexOf(a) !== -1) : list;
    }

    if (!pageId) return null;

    const detailPageImage = organization?.avatar;

    let modalImage: any = {};

    if (detailPageImage !== '(none)' && detailPageImage) {
        modalImage = {
            backgroundImage: `url("${detailPageImage.replace(/ /g, '%20')}")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '300px 168.75px',
        };
    }

    if (!database || !database.fields || !page) return null;

    const specialFields = getSpecialPageFieldKeysForDatabase(specialKeys, database);

    for (const key in specialFields)
        specialFields[key] = JSON.parse(page?.row?.map?.[specialFields[key]] || null);

    const {
        page_title,
        organization_name_or_collins_department,
        resource_description,
        program_focus_area,
        resource_type,
        resource_location,
        identity_specifier,
        ages_served,
        grades_served,
        program_availability,
        cost,
        contact_name,
        cotnact_phone_number,
        contact_email,
        street_address,
        city,
        state,
        zip_code,
        website_link,
    } = specialFields as any;

    const actionButtons = [
        <button
            className="btn btn-primary"
            key="detail-modal-done"
            onClick={() => setShow(false)}>
            Done
        </button>,
    ];

    const dbFocusAreas = database?.fields?.find(f => `${f.name}`.includes('program_focus_area_')) as IDatabaseField
    const dbResourceType = database?.fields?.find(f => `${f.name}`.includes('"resource_type"')) as IDatabaseField
    const dbIdentitySpecifier = database?.fields?.find(f => `${f.name}`.includes('"identity_specifier"')) as IDatabaseField
    const dbAgesServed = database?.fields?.find(f => `${f.name}`.includes('ages_served')) as IDatabaseField
    const dbGradesServed = database?.fields?.find(f => `${f.name}`.includes('grades_served')) as IDatabaseField
    const dbProgramAvailability = database?.fields?.find(f => `${f.name}`.includes('program_availability')) as IDatabaseField
    const dbCost = database?.fields?.find(f => `${f.name}`.includes('cost')) as IDatabaseField

    return (
        <Modal
            large
            id={`detailModal`}
            actionButtons={actionButtons}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                    style={{
                        backgroundImage: modalImage.backgroundImage,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        minHeight: 100,
                        width: '100%',
                    }}
                />
                {page_title && (
                    <div style={{ textAlign: 'center' }} className="pt-3">
                        {page_title && <h2>{page_title}</h2>}
                    </div>
                )}

                {resource_description && <div style={{ padding: 20 }}>{resource_description}</div>}
                {program_focus_area &&
                    renderDetailModalSection(
                        <em className="fas fa-book-open text-muted" style={{ fontSize: 16 }} />,
                        'Program Focus Area',
                        <div>
                            <ul className="pl-4 pb-0">
                                {sortList(filterList(program_focus_area, dbFocusAreas), dbFocusAreas)?.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                {resource_type &&
                    renderDetailModalSection(
                        <em className="fas fa-book-open text-muted" style={{ fontSize: 16 }} />,
                        'Resource Type',
                        <div>
                            <ul className="pl-4 pb-0">
                                {sortList(filterList(resource_type, dbResourceType), dbResourceType)?.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                {resource_location &&
                    renderDetailModalSection(
                        <em className="fas fa-laptop text-muted" style={{ fontSize: 16 }} />,
                        'Resource Location',
                        <div className="pl-2">{resource_location}</div>
                    )}
                {identity_specifier &&
                    renderDetailModalSection(
                        <em className="fas fa-book-open text-muted" style={{ fontSize: 16 }} />,
                        'Identity Specifier',
                        <div>
                            <ul className="pl-4 pb-0">
                                {sortList(filterList(identity_specifier, dbIdentitySpecifier), dbIdentitySpecifier)?.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                {ages_served &&
                    renderDetailModalSection(
                        <em className="fas fa-book-open text-muted" style={{ fontSize: 16 }} />,
                        'Ages Served',
                        <div>
                            <ul className="pl-4 pb-0">
                                {sortList(filterList(ages_served, dbAgesServed), dbAgesServed)?.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                {grades_served &&
                    renderDetailModalSection(
                        <em className="fas fa-book-open text-muted" style={{ fontSize: 16 }} />,
                        'Grades Served',
                        <div>
                            <ul className="pl-4 pb-0">
                                {sortList(filterList(grades_served, dbGradesServed), dbGradesServed)?.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                {program_availability &&
                    renderDetailModalSection(
                        <em className="fas fa-book-open text-muted" style={{ fontSize: 16 }} />,
                        'Program Availability',
                        <div>
                            <ul className="pl-4 pb-0">
                                {sortList(filterList(program_availability, dbProgramAvailability), dbProgramAvailability)?.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                {cost &&
                    renderDetailModalSection(
                        <em className="fas fa-book-open text-muted" style={{ fontSize: 16 }} />,
                        'Cost',
                        <div>
                            <ul className="pl-4 pb-0">
                                {sortList(filterList(cost, dbCost), dbCost)?.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                {(contact_name || cotnact_phone_number || contact_email) &&
                    renderDetailModalSection(
                        <em className="fas fa-address-card text-muted" style={{ fontSize: 16 }} />,
                        'Contact Information',
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="pl-2">
                                {contact_name}
                                {cotnact_phone_number && <div><a href={`tel:+1${cotnact_phone_number.replace(/\D/g, '')}`}>{cotnact_phone_number}</a></div>}
                                {contact_email && <div><Linkify>{contact_email}</Linkify></div>}
                            </div>
                        </div>
                    )}
                {(street_address || city || state || zip_code) &&
                    renderDetailModalSection(
                        <em className="fas fa-map-marker text-muted" style={{ fontSize: 16 }} />,
                        'Program Address',
                        <a target="_blank" href={`https://maps.google.com/?q=${street_address} ${city}, ${state}, ${zip_code}`}>
                            <div>{street_address || ''}</div>
                            <div>{[city, state, zip_code].filter((x) => x).join(', ')}</div>
                        </a>
                    )}
                {website_link &&
                    renderDetailModalSection(
                        <em className="fas fa-globe text-muted" style={{ fontSize: 16 }} />,
                        'Website Link',
                        <div className="pl-2">
                            <a target="_blank" href={website_link?.includes('http') ? website_link : `http://${website_link}`}>{website_link}</a>
                        </div>
                    )}
                {!!attachments?.length && <section id="attachments" className="py-5">
                    <div className="container">
                        <h4>Attachments</h4>
                        <ul className="pdf-list d-flex flex-wrap">
                            {attachments?.map(renderAttachment)}
                        </ul>
                    </div>
                </section>}
            </div>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/public/pages/CustomOneTemplateModal.tsx